import type { AxiosInstance } from 'axios';
import type { Profile } from '../../types/Profile';

export interface UpdateProfileRequest {
  name?: string;
  picture?: string;
  bio?: string;
  handle?: string;
  flair?: string;
  selectedLabId?: string;
}

export const ProfileService = (api: AxiosInstance) => ({
  // Get own profile
  getOwnProfile: async () => {
    try {
      const response = await api.get<Profile>('/profile');

      // If backend doesn't return subscription data, provide default features
      // TODO: this needs to be removed before we go live, and we need to log out the user if they don't have a Stripe account ID
      if (!response.data.subscription) {
        return {
          ...response.data,
          subscription: {
            access: ['bettor', 'creator']
          }
        };
      }

      // Otherwise, use the subscription data from backend as-is
      return response.data;
    } catch (error) {
      console.error('Error getting own profile:', error);
      return null;
    }
  },

  // Update own profile
  updateProfile: async (data: UpdateProfileRequest) => {
    try {
      const response = await api.put<Profile>('/profile', data);
      return response.data;
    } catch (error) {
      console.error('Error updating profile:', error);
      throw error;
    }
  },

  // Upsert a given preference
  upsertPreference: async (preference: {name: string, value: string}) => {
    const response = await api.put<Profile>(`/profile/preferences/${preference.name}`, { value: preference.value });
    return response.data;
  },

  // Delete a given preference
  deletePreference: async (preference: {name: string}) => {
    const response = await api.delete<Profile>(`/profile/preferences/${preference.name}`);
    return response.data;
  },

  // Get public profile by userId
  getPublicProfile: async (userId: string) => {
    const response = await api.get<Profile>(`/profile/${userId}`);
    return response.data;
  },

  // check if a handle is available
  checkHandleAvailability: async (handle: string) => {
    const response = await api.get<{available: boolean}>(`/profile/handles/check?handle=${handle}`);
    return response.data.available;
  }
}); 